import { useState } from "react";
import { LoadingState, StoredSubmission } from "@/types/fitconnect.ts";
import { getStoredSubmissions } from "@/lib/fitconnect.ts";
import { toast } from "sonner";

export const useStoredSubmissions = (onlyReplyEnabledOnes: boolean) => {
  const [listLoadingState, setListLoadingState] =
    useState<LoadingState>("initial");
  const [listResponseData, setListResponseData] = useState<StoredSubmission[]>(
    [],
  );
  if (listLoadingState === "initial") {
    setListLoadingState("pending");
    getStoredSubmissions(onlyReplyEnabledOnes)
      .then((response) => {
        setListResponseData(response.submissions);
        setListLoadingState(response.error ? "error" : "success");
        if (response.error) {
          toast.error("Submission-Liste abfragen fehlgeschlagen", {
            description: response.error,
          });
        }
      })
      .catch((error) => {
        setListLoadingState("error");
        setListResponseData([]);
        toast.error("Submission-Liste abfragen fehlgeschlagen", {
          description: error.message || "unbekannter Fehler",
        });
      });
  }

  return { listLoadingState, listResponseData };
};
